// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2KRry","label":"Radio_label__3pWB5","checkMark":"Radio_checkMark__17tty","disabled":"Radio_disabled__BVxVM"};